import React from "react";
import { orderBy } from "lodash";
import { RLCSMergedReportResponse } from "../../../../samples/@types/rldynamicanalysis/rlcs-responses";
import { Grid } from "../../../../../components/Grid";
import { RlCloudSandboxSignaturesGridSchema } from "../../../../samples/components/rlcloudsandbox/signatures/RlCloudSandboxSignaturesGridSchema";
import styles from "./network-lists.module.scss";
import RenderWhen from "../../../../../components/RenderWhen";
import { RLcsAnalysisResponseData } from "../../../../samples/components/rlcloudsandbox/hooks/useRlcsAnalysisStatus";
import ThreeDotsLoader from "../../../../../components/three-dots-loader/ThreeDotsLoader";

interface LoadingProps {
  isLoading?: boolean;
  displayStatus?: string;
}

const LoadingComponent = ({ isLoading, displayStatus }: LoadingProps) => (
  <div className={styles.status_msg}>
    <span>{isLoading ? "Loading" : displayStatus ?? "Queued"}</span>
    <ThreeDotsLoader />
  </div>
);

interface NoDataComponentProps {
  showAnalyzeMessage: boolean;
  rlcsAnalyzeModalToggle: () => void;
}

const NoDataComponent = ({
  showAnalyzeMessage,
  rlcsAnalyzeModalToggle
}: NoDataComponentProps) => (
  <RenderWhen
    condition={showAnalyzeMessage}
    fallback={
      <div className={styles.empty_msg}>
        <span
          className={"network-threat-intel-link k-pdf-rl-cloud-sandbox-analyze"}
          onClick={rlcsAnalyzeModalToggle}
          data-test-id="analyze-rlcs-card-findings"
        >
          Analyze with RL Cloud Sandbox
        </span>
        <span> to gather dynamic analysis data</span>
      </div>
    }
  >
    <span className={styles.empty_msg}>No Available Signatures</span>
  </RenderWhen>
);

interface Props {
  mergedReport: RLCSMergedReportResponse | undefined;
  rlcsAnalyzeModalToggle: () => void;
  isAnalyzing?: boolean;
  isLoading?: boolean;
  analysisStatusData?: RLcsAnalysisResponseData;
}

const DynamicAnalysisFindingsList: React.FC<Props> = ({
  mergedReport,
  rlcsAnalyzeModalToggle,
  isAnalyzing,
  isLoading,
  analysisStatusData
}) => {
  const sortedData = orderBy(
    mergedReport?.signatures,
    ["risk_factor"],
    ["desc"]
  ).slice(0, 5);

  return (
    <div className="flex-column">
      <Grid
        data={sortedData}
        schema={RlCloudSandboxSignaturesGridSchema()}
        emptyGridMsg={
          <NoDataComponent
            showAnalyzeMessage={Boolean(mergedReport)}
            rlcsAnalyzeModalToggle={rlcsAnalyzeModalToggle}
          />
        }
        showLoading={isLoading || isAnalyzing}
        LoadingComponent={
          <LoadingComponent
            isLoading={isLoading}
            displayStatus={analysisStatusData?.display_status}
          />
        }
      />
    </div>
  );
};
export default DynamicAnalysisFindingsList;
